module.exports = {
	"LANGUAGE": "언어",
	"HDR-obpa_fulltext_score": "점수",
	"HDR-obpa_name": "이름",
	"HDR-obpa_fulltext_summary": "개요",
	"QUERY LIMIT REACHED": "표시되는 것보다 많은 결과가 있습니다. 검색 기준을 좁히십시오.",
	"NO DOCUMENTS FOUND": "문서를 찾을 수 없습니다.",
	"OPEN IN NEW WINDOW": "새 창에서 열기",
	"DOWNLOAD NATIVE": "네이티브 형식으로 다운로드",
	"CLOSE": "닫기",
	"SEARCH TYPE": "검색 유형",
	"DOCUMENT TYPE": "문서 유형",
	"SEARCH TERM": "검색어",
	"SEARCH": "수색",
	"RESET": "다시 놓기",
	"DATE": "날짜",
	"FROM DATE": "날짜부터",
	"TO DATE": "오늘까지",
	"LOADING": "로드 중 ...",
	"RETRY": "다시 해 보다",
	"ERROR": "오류!",
	"ERROR: QUERIES": "검색 유형 목록을 검색 할 수 없습니다.",
	"ERROR: DOCTYPES": "문서 유형 목록을 검색 할 수 없습니다.",
	"ERROR: KEYWORDS": "검색 필드 목록을 검색 할 수 없습니다.",
	"ERROR: DOCUMENTS": "요청한 검색을 수행 할 수 없습니다.",
	"FORM: INVALID FULLTEXT": "입력란은 {{chars}} 자 이상이어야합니다.",
	"FORM: INVALID DATE SHORT": "체재: {{format}} .",
	"FORM: REQUIRED KEYWORD": "필드가 필요합니다.",
	"FORM: INVALID NUMERIC": "필드는 {{digits}} 자리 숫자 여야합니다.",
	"FORM: INVALID DATE": "필드는 형식을 따라야합니다. {{format}} .",
	"FORM: INVALID CURRENCY": "필드는 유효한 통화 값이어야합니다.",
	"FORM: INVALID FLOAT": "필드는 숫자 여야합니다.",
	"FORM: INVALID LENGTH": "입력란은 {{chars}} 자 이하 여야합니다.",
	"FORM: ERRORS": "양식에 오류가 있습니다.",
	"FORM: noDate": "기간을 지정해야합니다.",
	"FORM: noKeyword": "하나 이상의 입력란을 지정해야합니다.",
	"FORM: noDateOrKeyword": "날짜 범위 또는 하나 이상의 필드를 지정해야합니다.",
	"FORM: noDateAndKeyword": "기간 및 하나 이상의 필드를 지정해야합니다."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/ko.json
// module id = 357
// module chunks = 0